<template>
  <div class="container">
    <div class='search-feedback'>
      <div class='feedback-header'>
        <span>告诉我们</span>
        <span>你想要的商品</span>
      </div>
      <div class='feedback-form'>
        <div class="feedback-num flex space-between">
          <div class='flex'>
            <div class='label'><span class='iconfont icon-shoucangshangpinzanwu'></span>商品名</div>
            <input
              class="weui-input"
              maxlength="100"
              placeholder="填写商品名"
              v-model="inputNameValue"
              @blur="blurScroll"/>
            <div class="clear-name">
              <i
                class='mintui mintui-field-error'
                v-if="inputNameValue.length > 0"
                @click="clearContent('name')">
              </i>
            </div>
          </div>
        </div>
        <div class="feedback-num flex space-between">
          <div class='flex'>
            <div class='label'><span class='iconfont icon-biaoqian'></span>售价</div>
            <input
              class="weui-input"
              type="text"
              maxlength="7"
              placeholder="输入你期望的售价"
              v-model="inputPriceValue"
              @blur="bindPriceBlur"
              @keyup="bindPriceInput"/>
            <div class="clear-name">
              <i
                class='mintui mintui-field-error'
                v-if="inputPriceValue.length > 0"
                @click="clearContent('price')">
              </i>
            </div>
          </div>
        </div>
      </div>
      <div class='feeback-btn'>
        <button class='b_black' @click='submitFeedback' :disabled='isFeedback'>提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import { SaveHopeProduct } from '@/api/search'
import { Indicator, Toast } from 'mint-ui'
export default {
  data () {
    return {
      inputNameValue: '',
      inputPriceValue: '',
      isName: false,
      isPrice: false,
      isFeedback: false
    }
  },
  mounted () {
    this.inputNameValue = this.$route.query.keyword
  },
  methods: {
    // 售价输入框
    bindPriceInput () {
      if (this.inputPriceValue) {
        this.inputPriceValue = this.inputPriceValue.replace(/[^\d.]/g, '')
          .replace(/^\./g, '').replace(/\.{2,}/g, '.')
          .replace('.', '$#$').replace(/\./g, '')
          .replace('$#$', '.').replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
        this.overPrice()
      }
    },
    bindPriceBlur () {
      this.bindPriceInput()
      this.overPrice()
      this.blurScroll()
    },
    overPrice () {
      let tempPrice = Number(this.inputPriceValue)
      if (tempPrice > 10000) {
        this.inputPriceValue = 9999.99
      }
    },
    blurScroll () {
      setTimeout(function () {
        window.scrollTo(0, 0)
      }, 100)
    },
    // 清空输入文本框
    clearContent (val) {
      if (val === 'name') {
        this.inputNameValue = ''
      } else {
        this.inputPriceValue = ''
      }
    },
    submitFeedback () {
      if (!this.isFeedback) {
        if (!this.inputNameValue.trim()) {
          Toast('商品名不能为空')
          return
        }
        if (!this.inputPriceValue) {
          Toast('售价不能为空')
          return
        }
        if (this.inputPriceValue < 1) {
          Toast('售价不能小于1元')
          return
        }
        let params = {
          productName: this.inputNameValue,
          price: this.inputPriceValue
        }
        Indicator.open({
          text: '加载中',
          spinnerType: 'triple-bounce'
        })
        SaveHopeProduct(params).then(res => {
          this.isFeedback = true
          Indicator.close()
          if (res.success) {
            Toast({
              message: '反馈成功',
              iconClass: 'mint-toast-icon mintui mintui-success'
            })
            setTimeout(() => {
              this.$router.go(-2)
            }, 2000)
          } else {
            Toast(res.msg)
          }
        }).catch(() => {
          Indicator.close()
        })
      }
    }
  }
}
</script>

<style scoped>
  .feedback-form{
    background-color: #ffffff;
  }
  .feedback-header {
    margin: 80px 0 50px;
  }
  .feedback-header span {
    width: 100%;
    display: block;
    text-align: center;
  }
  .feedback-header span:nth-of-type(2) {
    font-size: 16px;
    color: #20a0ff;
    margin-top: 5px;
  }
  .flex {
    display: flex;
  }
  .space-between {
    justify-content: space-between;
  }
  .feeback-btn {
    padding: 6% 6%;
  }
  .feeback-btn button{
    font-size: 14px;
    padding: 4px;
    width: 100%;
    height: 45px;
    text-align: center;
    border-radius: 5px;
  }
  .b_black {
    background: #2c2c2c;
    color: #fff;
  }
  .feedback-form {
    border: 1px solid #ddd;
    margin: 6% 6% 0 6%;
    border-radius: 4px;
    word-break: keep-all;
  }
  .feedback-num {
    line-height: 45px;
    height: 45px;
    font-size: 14px;
    padding: 0 0 0% 3%;
    border-bottom: 1px solid #ddd;
  }
  .feedback-num:last-child {
    border-bottom: none;
  }
  .feedback-num>div{
      width: 100%;
  }
  .feedback-num span {
    font-size: 14px;
    min-width: 80px;
    font-size: 16px;
  }
  .feedback-num input {
    flex:7;
    line-height: 45px;
    height: 45px;
    margin-left: 10px;
    color: #333;
    padding-right: 20px;
    box-sizing: border-box;
  }
  .feedback-num .label {
    flex: 3;
    width: 75px;
    color: #333;
  }
  .feedback-num .label>span{
    margin-right: 5px;
  }
  .feedback-num .label .icon-shouji {
    font-size: 19px;
  }
  .feedback-num .iconfont {
    color: #555;
  }
  .clear-name{
    flex: 1;
  }
  .clear-name .mintui{
    font-size: 20px;
  }
</style>
